import { Link } from 'react-router'
import { useMergeRefs } from '@floating-ui/react'
import { SubNavTabLinkProps } from 'components/subnav/types.ts'

const SubNavTabLink = ({ tab, anchorRef, ref, ...props }: SubNavTabLinkProps) => (
  <Link to={tab.path} onPointerDown={tab.onClick} ref={useMergeRefs([ref, anchorRef])} {...props}>
    {tab.label}
  </Link>
)

export default SubNavTabLink
